export function initGaEvents() {
    document.addEventListener('click', (event) => {
        const link = event.target.closest('.js-ga4-contact-conversion');

        if (!link || !window.dataLayer) {
            return;
        }

        window.dataLayer.push({
            event: 'conversion_event_contact',
            page_location: window.location.href,
            link_text: link.textContent.trim(),
            link_url: link.href,
        });
    });
}
